module.exports = __webpack_public_path__ + "img/graph_5.08e1e16d.png";